import { call, put, select } from 'redux-saga/effects';

import { getData } from '../../services/API';
import {
  employeeRoundHistoryUrl,
  getCensusReportUrl,
  getComplianceReportUrl,
  getEmpComplianceReportUrl,
  getEmployeeFreqUrl,
  getEmployeeRoundsUrl,
  getEmployeeRoundsReportUrl,
  getPatientRoundsUrl,
  getPatientRoundsReportUrl,
  patientHistorySearchUrl,
  patientRoundHistoryUrl
} from '../../services/API/endpoints';

import {
  getCSVToExport,
  getCSVToExportSuccess,
  getCSVToExportFailure,
  searchPatientHistorySuccess,
  getPatientRoundHistorySuccess,
  getPatientRoundHistoryFailure,
  getEmployeeRoundHistorySuccess,
  getEmployeeRoundHistoryFailure,
  getPatientRoundsReportSuccess,
  getPatientRoundsReportFailure,
  getEmployeeRoundsReportSuccess,
  getEmployeeRoundsReportFailure,
  getEmployeeFreqReportSuccess,
  getEmployeeFreqReportFailure,
  getComplianceReportSuccess,
  getComplianceReportFailure,
  getCensusReportSuccess,
  getCensusReportFailure,
  setToastOptions,
  slideIn,
  getDataToDownloadSuccess
} from '../actions';

import { date, employeeHireDateHelper } from '../../utils/helpers';
import qualifyingEmpRoundingTemplates from '../../constants/qualifyingEmpRoundingTemplates.json';

// Report sagas
export function* searchPatientHistorySaga({ payload }) {
  let url;
  const { facilityId, patientSearch } = payload;
  if (patientSearch.match(/\d+/g)) {
    url = `${patientHistorySearchUrl}?facilityId=${facilityId}&mrn=${patientSearch}&page=-1`;
  } else {
    url = `${patientHistorySearchUrl}?facilityId=${facilityId}&name=${patientSearch}&page=-1`;
  }
  try {
    const { data, status } = yield call(getData, url);
    if (status === 200) {
      yield put(searchPatientHistorySuccess(data));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* getPatientRoundHistorySaga({ payload }) {
  const { facilityId, patientId } = payload;
  const url = `${patientRoundHistoryUrl}?facilityId=${facilityId}&patientId=${patientId}`;
  try {
    const { data, status } = yield call(getData, url);
    if (status === 200) {
      return yield put(getPatientRoundHistorySuccess(data));
    }
    console.log(`ERROR :${status}`);
    return yield put(getPatientRoundHistoryFailure());
  } catch (error) {
    console.log(`ERROR IS :${error}`);
    return yield put(getPatientRoundHistoryFailure());
  }
}

export function* getEmployeeRoundHistorySaga({ payload }) {
  const { employeeId, roundingTypes } = payload;
  const url = `${employeeRoundHistoryUrl}?employeeId=${employeeId}${
    roundingTypes?.length ? `&roundingTypes=${roundingTypes}` : ''
  }`;
  try {
    const { data, status } = yield call(getData, url);
    if (status === 200) {
      return yield put(getEmployeeRoundHistorySuccess(data));
    }
    console.log(`ERROR :${status}`);
    return yield put(getEmployeeRoundHistoryFailure());
  } catch (error) {
    console.log(`ERROR IS :${error}`);
    return yield put(getEmployeeRoundHistoryFailure());
  }
}

export function* getComplianceReportSaga({ payload }) {
  const { facilityId, startday, endday } = payload;

  const url = `${getComplianceReportUrl}?facilityId=${facilityId}&startday=${startday}&endday=${endday}`;
  try {
    const { data, status } = yield call(getData, url, payload);
    if (status === 200) {
      return yield put(getComplianceReportSuccess(data));
    }
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getComplianceReportFailure());
  } catch (error) {
    console.log(error);
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getComplianceReportFailure());
  }
}

export function* getEmpComplianceReportSaga({ payload }) {
  const { facilityId, startday, endday } = payload;

  const url = `${getEmpComplianceReportUrl}?facilityId=${facilityId}&startday=${startday}&endday=${endday}`;
  try {
    const { data, status } = yield call(getData, url, payload);
    if (status === 200) {
      return yield put(getComplianceReportSuccess(data));
    }
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getComplianceReportFailure());
  } catch (error) {
    console.log(error);
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getComplianceReportFailure());
  }
}

export function* getPatientRoundsReportSaga({ payload }) {
  const params = new URLSearchParams(payload).toString();
  const url = `${getPatientRoundsUrl}?${params}`;

  if (payload.unitId.length === 0)
    return yield put(
      getPatientRoundsReportSuccess({
        roundReportList: [],
        totalRecordCount: 0
      })
    );
  try {
    const { data, status } = yield call(getData, url);
    if (status === 200) {
      return yield put(getPatientRoundsReportSuccess(data));
    }
    return yield put(getPatientRoundsReportFailure());
  } catch (error) {
    console.log(error);
    return yield put(getPatientRoundsReportFailure());
  }
}

export function* getPatientRoundsReportDownloadSaga({ payload }) {
  const {
    facilityId,
    unitId,
    query,
    roundedBy,
    sortBy,
    sortOrder,
    startday,
    endday,
    isDownload
  } = payload;

  const params = new URLSearchParams({
    facilityId,
    unitId,
    query,
    roundedBy,
    sortBy,
    sortOrder,
    startday,
    endday,
    isExport: true
  });
  const url = `${getPatientRoundsReportUrl}?${params}`;

  yield put(getCSVToExport());

  try {
    const { data, status } = yield call(getData, url, payload);
    if (status === 200) {
      const patientRoundsReportList =
        data?.map(round => {
          // This is mapping out the answers
          const answersWithIndex =
            round.answers?.map((ans, index) => {
              return {
                [`question${index + 1}`]: ans?.question?.replaceAll('"', ''),
                [`answer${index + 1}`]:
                  ans?.answer && ans.answer.length > 0
                    ? ans?.answer[0].value
                    : ''
              };
            }) || [];

          const ansObject = answersWithIndex.reduce((acc, value) => {
            return {
              ...acc,
              ...value
            };
          }, {});

          return {
            unit: round?.unit || '',
            room: round?.room || '',
            patientId: round?.patientId || '',
            patient: `${round?.patientFirstName} ${round?.patientLastName}`,
            patientFirstName: round?.patientFirstName || '',
            patientLastName: round?.patientLastName || '',
            patientMRN: round?.patientMRN || '',
            createdUserName: `${round?.userFirstName} ${round?.userLastName}`,
            createdUserId: round?.userId || '',
            accountNumber: round?.accountNum || '',
            facilityId: round?.facilityId || '',
            status: round.status === 'rounded' ? 'Rounded' : 'Unable To Round',
            date:
              round?.roundDate && date.isOrbitTimestamp(round?.roundDate)
                ? date.parseDate(round?.roundDate).toLocaleString([], {
                    day: '2-digit',
                    month: '2-digit',
                    year: '2-digit'
                  })
                : '',
            time:
              round?.roundDate && date.isOrbitTimestamp(round?.roundDate)
                ? date.parseDate(round?.roundDate).toLocaleString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                  })
                : '',
            templateName: round?.templateName || '',
            ...ansObject
          };
        }) || [];

      if (isDownload) {
        return yield put(getDataToDownloadSuccess(patientRoundsReportList));
      }

      return yield put(getCSVToExportSuccess(patientRoundsReportList));
    }
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getCSVToExportFailure());
  } catch (error) {
    console.log(error);
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getCSVToExportFailure());
  }
}

export function* getCensusReportDownloadSaga({ payload }) {
  const { isCensusDownload } = yield select(state => state.ReportReducer);
  const params = new URLSearchParams(payload).toString();

  const url = `${getCensusReportUrl}?${params}`;

  yield put(getCSVToExport());
  try {
    const { data, status } = yield call(getData, url, payload);

    if (status === 200) {
      const censusReportList =
        data?.map(census => {
          return {
            censusDate: date.formatDateDashtoSlash(census?.reportDate),
            unit: census?.unitName,
            unitId: census?.unitId,
            room: census?.room || '',
            patient: `${census?.firstName} ${census?.lastName}` || '',
            mrn: census?.mrn || '',
            roundDate: census.rounds[0]?.roundDate || '',
            roundedBy:
              census?.status === 'none'
                ? ''
                : census?.rounds.length > 0
                ? `${census.rounds[0]?.userFirstName} ${census.rounds[0]?.userLastName}`
                : '',
            status:
              census?.status === 'none'
                ? 'Not Rounded'
                : census?.status === 'rounded'
                ? 'Rounded'
                : 'Unable To Round'
          };
        }) || [];
      if (isCensusDownload) {
        return yield put(getDataToDownloadSuccess(censusReportList));
      }
      return yield put(getCSVToExportSuccess(censusReportList));
    }
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getCSVToExportFailure());
  } catch (error) {
    console.log(error);
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getCSVToExportFailure());
  }
}
export function* getCensusReportSaga({ payload }) {
  const params = new URLSearchParams(payload).toString();

  const url = `${getCensusReportUrl}?${params}`;
  try {
    const { data, status } = yield call(getData, url, payload);

    if (status === 200) {
      return yield put(getCensusReportSuccess(data));
    }
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getCensusReportFailure());
  } catch (error) {
    console.log(error);
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getCensusReportFailure());
  }
}

export function* getEmployeeRoundsReportSaga({ payload }) {
  const params = new URLSearchParams(payload).toString();
  const url = `${getEmployeeRoundsUrl}?${params}`;

  try {
    const { data, status } = yield call(getData, url);
    if (status === 200) {
      return yield put(getEmployeeRoundsReportSuccess(data));
    }
    return yield put(getEmployeeRoundsReportFailure());
  } catch (error) {
    console.log(error);
    return yield put(getEmployeeRoundsReportFailure());
  }
}

export function* getEmployeeRoundsReportDownloadSaga({ payload }) {
  const {
    facilityId,
    query,
    roundedBy,
    templateName,
    departments,
    sortBy,
    sortOrder,
    startday,
    endday,
    isDownload
  } = payload;

  const params = new URLSearchParams({
    facilityId,
    query,
    roundedBy,
    templateName,
    departments,
    startday,
    endday
  });
  const url = `${getEmployeeRoundsReportUrl}?${params}`;

  // TODO: Should these be removed
  // const complianceTags = [
  //   'CompletedByManagerOrDelegate',
  //   'CompletedByManagerOrDelegateWithQualifyingTemplate'
  // ];

  yield put(getCSVToExport());

  try {
    const { data, status } = yield call(getData, url, payload);
    if (status === 200) {
      const mostRecentRoundCleanData =
        data
          ?.filter(
            round =>
              qualifyingEmpRoundingTemplates.includes(round.templateName) ||
              round?.complianceStatus === 'notrounded'
          )
          .reduce((acc, round) => {
            return [
              ...acc,
              {
                roundId: round?.roundId || '',
                department: round?.employeeDept || 'Unknown',
                employee:
                  `${round?.employeeFirstName} ${round?.employeeLastName}` ||
                  '',
                employeeId: round?.employeeId || '',
                employeeFirstName: round?.employeeFirstName || '',
                employeeLastName: round?.employeeLastName || '',
                employeeHireDate: employeeHireDateHelper(
                  round?.employeeHireDate
                )
                  ? date.datePrettier(round?.employeeHireDate)
                  : 'Unknown',
                roundedBy:
                  round?.userFirstName && round?.userLastName
                    ? `${round?.userFirstName} ${round?.userLastName}`
                    : '',
                createdUserId: round?.userId || '',
                facilityId: round?.facilityId || '',
                date: round?.roundDate || '',
                roundDate: round?.roundDate
                  ? date.dayOfYr(round?.roundDate)
                  : '',
                status:
                  round?.complianceStatus === 'compliant'
                    ? 'Compliant'
                    : round?.complianceStatus === 'notrounded'
                    ? 'Not Rounded'
                    : 'Rounded',
                templateName:
                  round?.templateName === 'Unknown'
                    ? ''
                    : round?.templateName || '',
                answers: round?.answers || []
              }
            ];
          }, []) || [];

      // TODO: Front-end has to handle sorting until mobile no longer needs export endpoint
      if (sortBy === 'employeeDept') {
        if (sortOrder === 'asc') {
          mostRecentRoundCleanData.sort((a, b) =>
            a.department.localeCompare(b.department)
          );
        } else {
          mostRecentRoundCleanData.sort((a, b) =>
            b.department.localeCompare(a.department)
          );
        }
      } else if (sortBy === 'employeeName') {
        if (sortOrder === 'asc') {
          mostRecentRoundCleanData.sort((a, b) =>
            a.employee.localeCompare(b.employee)
          );
        } else {
          mostRecentRoundCleanData.sort((a, b) =>
            b.employee.localeCompare(a.employee)
          );
        }
      } else if (sortBy === 'complianceStatus') {
        if (sortOrder === 'asc') {
          mostRecentRoundCleanData.sort(() => 0);
        } else {
          mostRecentRoundCleanData.sort(() => 0);
        }
      } else if (sortBy === 'roundedBy') {
        if (sortOrder === 'asc') {
          mostRecentRoundCleanData.sort((a, b) =>
            a.roundedBy.localeCompare(b.roundedBy)
          );
        } else {
          mostRecentRoundCleanData.sort((a, b) =>
            b.roundedBy.localeCompare(a.roundedBy)
          );
        }
      } else if (sortBy === 'templateName') {
        if (sortOrder === 'asc') {
          mostRecentRoundCleanData.sort((a, b) =>
            a[sortBy].localeCompare(b[sortBy])
          );
        } else {
          mostRecentRoundCleanData.sort((a, b) =>
            b[sortBy].localeCompare(a[sortBy])
          );
        }
      } else if (sortBy === 'roundDate') {
        if (sortOrder === 'asc') {
          mostRecentRoundCleanData.sort((a, b) => a.date.localeCompare(b.date));
        } else {
          mostRecentRoundCleanData.sort((a, b) => b.date.localeCompare(a.date));
        }
      }
      if (isDownload) {
        return yield put(getDataToDownloadSuccess(mostRecentRoundCleanData));
      }

      const extrapolatedAnswersRoundsData = mostRecentRoundCleanData.map(
        round => {
          // This is mapping out the answers
          const answers =
            round.answers?.map(ans => {
              return {
                question: ans.question,
                answer:
                  ans?.answer && ans.answer.length > 0
                    ? ans?.answer[0].value
                    : ''
              };
            }) || [];

          const answersWithIndex = answers.map((obj, index) => {
            return {
              [`question${index + 1}`]: obj?.question?.replaceAll('"', ''),
              [`answer${index + 1}`]: obj?.answer
            };
          });
          const ansObject = answersWithIndex.reduce((acc, value) => {
            return {
              ...acc,
              ...value
            };
          }, {});

          return {
            ...round,
            type: round.templateName,
            ...ansObject
          };
        }
      );

      return yield put(getCSVToExportSuccess(extrapolatedAnswersRoundsData));
    }
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getCSVToExportFailure());
  } catch (error) {
    console.log(error);
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getCSVToExportFailure());
  }
}

export function* getEmployeeFreqReportSaga({ payload }) {
  const params = new URLSearchParams(payload).toString();
  const url = `${getEmployeeFreqUrl}?${params}`;

  try {
    const { data, status } = yield call(getData, url);
    if (status === 200) {
      return yield put(getEmployeeFreqReportSuccess(data));
    }
    return yield put(getEmployeeFreqReportFailure());
  } catch (error) {
    console.log(error);
    return yield put(getEmployeeFreqReportFailure());
  }
}

export function* getEmployeeFreqReportDownloadSaga({ payload }) {
  const { facilityId, query, sortBy, sortOrder, startday, endday } = payload;

  const params = new URLSearchParams({
    facilityId,
    query,
    startday,
    endday
  });

  const url = `${getEmployeeRoundsReportUrl}?${params}&isFrequencyReport=true`;

  yield put(getCSVToExport());

  try {
    const { data, status } = yield call(getData, url, payload);
    if (status === 200) {
      const collapsedFreqReportWithAnswersExtrapolated =
        data?.reduce((acc, round) => {
          const foundEmpIndex = acc.findIndex(
            r =>
              `${r?.employeeId}:${r?.department || 'Unknown'}` ===
              `${round?.employeeId}:${round?.employeeDept || 'Unknown'}`
          );
          const answers =
            round.answers?.map(ans => {
              return {
                question: ans.question,
                answer:
                  ans?.answer && ans.answer.length > 0
                    ? ans?.answer[0].value
                    : ''
              };
            }) || [];
          const answersWithIndex = answers.map((obj, index) => {
            return {
              [`question${index + 1}`]: obj?.question?.replaceAll('"', ''),
              [`answer${index + 1}`]: obj?.answer
            };
          });
          const ansObject = answersWithIndex.reduce((ans, value) => {
            return {
              ...ans,
              ...value
            };
          }, {});
          const newRound = {
            department: round?.employeeDept || 'Unknown',
            employee:
              `${round?.employeeFirstName} ${round?.employeeLastName}` || '',
            employeeId: round?.employeeId || '',
            employeeFirstName: round?.employeeFirstName || '',
            employeeLastName: round?.employeeLastName || '',
            roundedBy: `${round?.userFirstName} ${round?.userLastName}`,
            createdUserId: round?.userId || '',
            date: round?.roundDate || '',
            type: round?.templateName || '',
            ...ansObject
          };
          if (foundEmpIndex === -1) {
            return [
              ...acc,
              {
                department: round?.employeeDept || 'Unknown',
                employeeId: round?.employeeId || '',
                employee:
                  `${round?.employeeFirstName} ${round?.employeeLastName}` ||
                  '',
                employeeFirstName: round?.employeeFirstName || '',
                employeeLastName: round?.employeeLastName || '',
                count: 1,
                rounds: [newRound]
              }
            ];
          }
          acc[foundEmpIndex].count += 1;
          acc[foundEmpIndex].rounds.push(newRound);
          return [...acc];
        }, []) || [];

      // TODO: Front-end has to handle sorting until mobile no longer needs export endpoint
      if (sortBy === 'employeeDept') {
        if (sortOrder === 'asc') {
          collapsedFreqReportWithAnswersExtrapolated.sort((a, b) =>
            a.department.localeCompare(b.department)
          );
        } else {
          collapsedFreqReportWithAnswersExtrapolated.sort((a, b) =>
            b.department.localeCompare(a.department)
          );
        }
      } else if (sortBy === 'employeeName') {
        if (sortOrder === 'asc') {
          collapsedFreqReportWithAnswersExtrapolated.sort((a, b) =>
            a.employee.localeCompare(b.employee)
          );
        } else {
          collapsedFreqReportWithAnswersExtrapolated.sort((a, b) =>
            b.employee.localeCompare(a.employee)
          );
        }
      } else if (sortBy === 'total') {
        if (sortOrder === 'asc') {
          collapsedFreqReportWithAnswersExtrapolated.sort(
            (a, b) => a.count - b.count
          );
        } else {
          collapsedFreqReportWithAnswersExtrapolated.sort(
            (a, b) => b.count - a.count
          );
        }
      }

      return yield put(
        getCSVToExportSuccess(collapsedFreqReportWithAnswersExtrapolated)
      );
    }
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getCSVToExportFailure());
  } catch (error) {
    console.log(error);
    yield put(
      setToastOptions({
        msg: 'Failed to retrieve report!',
        feedback: 'error',
        duration: 1200,
        speed: 350,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(getCSVToExportFailure());
  }
}
